module.exports = __webpack_public_path__ + "static/img/11.0a52a4ad.png";